import { render, staticRenderFns } from "./newsAll.vue?vue&type=template&id=783db44a&"
import script from "./newsAll.vue?vue&type=script&lang=ts&"
export * from "./newsAll.vue?vue&type=script&lang=ts&"
import style0 from "./newsAll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports